// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'layers-solid';

export const Component = () => (
  <path d='M12.26 12.813 0 8.405 12.26 4l12.262 4.406-12.261 4.406Zm0 4.885-8.14-2.921L0 16.26l12.262 4.406 12.26-4.406-4.118-1.484-8.142 2.92h-.001Zm0-3.928-8.14-2.92L0 12.333l12.262 4.406 12.26-4.406-4.118-1.485-8.142 2.921h-.001Z' />
);

export const viewBox = '0 0 25 25';
